<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">

        <div class="col-md-12">
          <div class="row margin-left-0px">
            <div class="col-md-1 padding-left-0px padding-right-0px">
              <img [src]="logo"
                   [style.width.px]="PrintlogoWidth"
                   [style.height.px]="PrintlogoHeight"
                   [style.border-radius.%]="PrintlogoBorderRadius"
                   class="">
            </div>

            <div class="col-md-6">
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{HeaderLine1}}</label>
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{HeaderLine2}}</label>
              </div>
              <div class="row margin-left-0px" *ngIf="GST">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{ClientHeaderSubTitle1}}:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{GST}}</label>
                </div>
              </div>
              <div class="row margin-left-0px" *ngIf="DL">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{ClientHeaderSubTitle2}}:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DL}}</label>
                </div>
              </div>
            </div>

            <div class="col-md-5 padding-right-5px border-color-blue">
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Customer Details</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead float-right font-weight-bold font-color-blue">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal font-color-blue">ID : {{PatientId}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Sex/Age : {{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal"><i class="fas fa-phone"></i> : {{l.Telephone1}}</label>
                </div>
              </div>

            </div>
          </div>

          <!--<div class="row margin-left-0px" *ngIf="SelectedPatientFormattedCode.FacilityName != 'Risaa IVF' && SelectedPatientFormattedCode.FacilityName != 'Ferticare IVF Assist'">
            <div class="col-md-1 padding-left-0px padding-right-0px">
              <img [src]="logo" class="user-image-circle-65px img7">
            </div>

            <div class="col-md-6">
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{HeaderLine1}}</label>
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{HeaderLine2}}</label>
              </div>
              <div class="row margin-left-0px" *ngIf="GST">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">GST:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{GST}}</label>
                </div>
              </div>
              <div class="row margin-left-0px" *ngIf="DL">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">CIN:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DL}}</label>
                </div>
              </div>
            </div>

            <div class="col-md-5 padding-right-5px border-color-blue">
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Customer Details</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead float-right font-weight-bold font-color-blue">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal font-color-blue">ID : {{PatientId}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Sex/Age : {{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal"><i class="fas fa-phone"></i> : {{l.Telephone1}}</label>
                </div>
              </div>

            </div>
          </div>

          <div class="row margin-left-0px" *ngIf="SelectedPatientFormattedCode.FacilityName == 'Risaa IVF' || SelectedPatientFormattedCode.FacilityName == 'Ferticare IVF Assist'">
            <div class="col-md-6 padding-left-0px">
              <div class="row margin-left-0px">
                <img [src]="logo" class="" width="350px" height="100px">
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{HeaderLine1}}</label>
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{HeaderLine2}}</label>
              </div>
              <div class="row margin-left-0px" *ngIf="GST">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">GST:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{GST}}</label>
                </div>
              </div>
              <div class="row margin-left-0px" *ngIf="DL">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">CIN:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DL}}</label>
                </div>
              </div>
            </div>

            <div class="col-md-6 padding-right-5px border-color-blue">
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Customer Details</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead float-right font-weight-bold font-color-blue">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal font-color-blue">ID : {{PatientId}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Sex/Age : {{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal"><i class="fas fa-phone"></i> : {{l.Telephone1}}</label>
                </div>
              </div>

            </div>
          </div>-->
        </div>

      </div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row bordertop5px">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead margin-bottom-0px">Invoice Cum Receipt</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style7" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>
        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Receipt No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{ReceiptFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{BillDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Branch}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Doctor:</label>
                </div>
                <div class="col-print-8" *ngIf="BillData2">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal" *ngIf="BillData2.PrescriberName!='' && BillData2.PrescriberName!='null'">{{BillData2.PrescriberName}}</label>
                  <!--<label class="margin-bottom-0px font-family float-left font-weight-normal" *ngIf="BillData2.PrescriberName=='' || BillData2.PrescriberName=='null'">Dr. Sunil Eshwar</label>-->
                  <!--<label class="margin-bottom-0px font-family float-right font-weight-normal" *ngIf="BillData2.PrescriberName=='' || BillData2.PrescriberName=='null'">Dr. Poornima</label>-->
                  <!--<label class="margin-bottom-0px font-family float-right font-weight-normal">{{BillData2.PrescriberName}}</label>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-bold background-primary padding-top-0px padding-bottom-0px font-family width-35px text-align-center">
                          #
                        </th>

                        <th class="font-weight-bold background-primary text-align-left padding-top-0px padding-bottom-0px font-family">
                          Item Description
                        </th>
                        <!--<th class="font-weight-bold background-primary text-align-left padding-top-0px padding-bottom-0px font-family">
                          Provider
                        </th>-->
                        <th class="font-weight-bold background-primary text-align-left padding-top-0px padding-bottom-0px font-family width-35px">
                          Qty
                        </th>
                        <th class="font-weight-bold background-primary text-align-right padding-top-0px padding-bottom-0px font-family width-50">
                          Price
                        </th>
                        <th class="font-weight-bold background-primary text-align-right padding-top-0px padding-bottom-0px font-family width-50" *ngIf="Discount>0">
                          Discount
                        </th>
                        <th class="font-weight-bold background-primary text-align-right padding-top-0px padding-bottom-0px font-family width-50">
                          Net
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentX_BillItemsController;let RowIndex = index">
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{l.ItemDescription}}</td>
                        <!--<td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{l.ProviderName}}</td>-->
                        <!--<td class="font-family padding-top-0px padding-bottom-0px text-align-left">
                          <div class="row margin-left-0px">
                            <div class="margin-right-3px">
                              <label class="margin-bottom-0px font-family">{{l.ItemDescription}}</label>
                            </div>
                          </div>
                          <div class="row margin-left-0px" *ngIf="l.ProviderCode!=0">
                            <div class="margin-right-3px">
                              <label class="margin-bottom-0px font-family">{{l.ProviderName}}</label>
                            </div>
                          </div>
                        </td>-->
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{l.Quantity}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right">{{l.UnitPrice | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right" *ngIf="Discount>0">{{l.Discount | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right">{{(l.Quantity * l.UnitPrice)-(l.Quantity * l.UnitPrice * (l.Discount / 100)) | number:'1.2-2'}}</td>

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Bill Summary:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-0px padding-bottom-0px font-family text-align-left">
                          Total
                        </th>

                        <th class="font-weight-normal background-primary text-align-right padding-top-0px padding-bottom-0px font-family" *ngIf="Discount>0">
                          Discount
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                    Tax
                  </th>-->
                        <th class="font-weight-normal background-primary text-align-right padding-top-0px padding-bottom-0px font-family">
                          Net (rounded)
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-0px padding-bottom-0px font-family">
                          Paid
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-0px padding-bottom-0px font-family">
                          Due
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-left">{{GrandTotal | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right" *ngIf="Discount>0">{{Discount | number:'1.2-2'}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{Tax | number:'1.2-2'}}</td>-->
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right">{{Net | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right">{{Net - Due | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-0px padding-bottom-0px text-align-right">{{Due | number:'1.2-2'}}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-10">
              <label class="margin-bottom-0px font-family font-weight-normal">Amount In Words: {{Net - Due | amountToWord}}</label>
            </div>
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family float-right font-weight-bold">{{Net - Due | number:'1.2-2'}}</label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-1">
              <label class="margin-bottom-0px font-family font-weight-bold">Cashier:</label>
            </div>
            <div class="col-print-6" *ngIf="CurrentX_BillHeaderController">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CurrentX_BillHeaderController.PayeeName}}</label>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5" *ngIf="CurrentX_BillHeaderController">
              <label class="margin-bottom-0px font-family font-weight-normal">( {{CurrentX_BillHeaderController.PayeeName}} )</label>
            </div>
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
